export default {
    text: {
        title: 'Testo',
        addText: 'Nuovo testo',
        fontFamily: 'Famiglia di font',
        fontSize: 'Font size',
        textAlignment: 'Allineamento del testo',
        fontColor: 'Colore del font',
        lineSpacing: 'Interlinea',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sans-serif)',
        trebuchetMSSansSerif: 'Trebuchet MS (senza grazie)',
        timesNewRomanSerif: 'Times New Roman (con grazie)',
        georgiaSerif: 'Georgia (carattere serif)',
        garamondSerif: 'Garamond (grassetto)',
        courierNewMonospace: 'Courier New (monospace)',
        brushScriptMTCursive: 'Pennello Script MT (corsivo)',
        backgroundColor: 'Colore di sfondo',
    },
};
